// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3Bf3J","content":"LoadingAlert_content__3KOSB"};